//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const emailTemplete = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getEmailTemplete(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/email-template?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }async function getEmailTemplete(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/email-template?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function exports(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/email-template/export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function updateEmailTemplete(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/email-template`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  


  return {
    getEmailTemplete,
    // createResponse,
    updateEmailTemplete,
    exports
  };
};

export default emailTemplete;
